import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import tool from '@/utils/tool'
import {Toast} from 'vant';
import NProgress from 'nprogress'
import routes_system from './modules/system'
import 'nprogress/nprogress.css' // progress bar style

Vue.use(VueRouter)

/**
 * 因为路由有优先级的概念，先定义的会先匹配，而自动注册是依据文件名的排序来遍历的
 * 所以下面这种情况，如果访问 /news/edit ，会指向到 info.vue 页面上
 * a.js   /news/:id   info.vue
 * b.js   /news/edit   edit.vue
 * 为避免这种情况发生，同一模块下的路由必须放在一个路由配置文件里
 * 按上面的例子，news 模块的路由，应该放到一个类似于 news.js 的文件里
 * 至于模块里的路由优先级，可以把 /news/edit 放在 /news/:id 前面，或者把 /news/:id 改成 /news/info/:id 均可
 */
const routes = routes_system
let routes_user = [];
const require_module = require.context('./modules', false, /.js$/)
require_module.keys().forEach(file_name => {
    if (file_name.indexOf('system') < 0) {
        let list = require_module(file_name).default;
        list.forEach(function (item) {
            routes_user.push(item)
        });
    }
})

const router = new VueRouter({
    routes: routes
})

router.onError((error) => {
    console.error('路由错误', error)
    NProgress.done();
    if (error.message.indexOf('Loading chunk') > -1 && tool.data.get('reloadTime') < (new Date()).getTime()) {
        // 旧资源缓存导致找不到，强制刷新一次
        tool.data.set('reloadTime', (new Date()).getTime() + 600 * 1000)
        window.location.reload()
    } else {
        Toast.fail(error.message);
    }

});


// 解决路由在 push/replace 了相同地址报错的问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

//判断是否已加载过动态/静态路由
var isGetRouter = false;
//加载动态/静态路由
if (!isGetRouter) {
    try {
        var menuRouter = filterAsyncRouter(routes_user)

        menuRouter = flatAsyncRoutes(menuRouter)
        menuRouter.forEach(item => {
            router.addRoute("Layout", item)
        })

        // 定义404页面路由
        router.addRoute({
            path: "/:pathMatch(.*)*",
            name: ":pathMatch(.*)*",
            component: () =>
                import('@/views/404'),
            meta: {
                title: '找不到页面'
            }
        });
        // let getRoutes = router.getRoutes();
        // console.log('getRoutes', getRoutes);
        isGetRouter = true;
    } catch (error) {
        console.error('router error', error)
    }
}

const config = store.state.config.data;

var title = config ? config['title'] : tool.data.get('title');
var sitename = config ? config['sitename'] : tool.data.get('sitename');
if (store.getters['token/isLogin']) {
    store.dispatch('token/getUserInfo');
}

const hasOwnProperty = function (obj, key) {
    if ('object' !== typeof obj) {
        return false;
    }
    return Object.prototype.hasOwnProperty.call(obj, key);
}

var $_GET = (function () {
    var url = window.document.location.href.toString();
    var u = url.split("?");
    if (typeof (u[1]) == "string") {
        u = u[1].split("&");
        var get = {};
        for (var i in u) {
            var j = u[i].split("=");
            get[j[0]] = j[1];
        }
        return get;
    } else {
        return {};
    }
})();

var $_QUERY = (function () {
    var url = window.document.location.href.toString();
    var u = url.split("?", 2);
    return u[1];
})();


if ($_GET && hasOwnProperty($_GET, 'go') && $_GET.go.substring(0, 1) == '/') {
    // console.log('$_GET', $_GET);
    window.location.href = '//' + window.location.host + '/#' + $_GET.go.trim() + '?' + $_QUERY;
    // next({
    //     path: $_GET.go.trim(),
    //     query: $_GET
    // })
}

//动态标题
router.beforeEach((to, from, next) => {
    NProgress.start()
    if (to.path != '/index' && to.path == '/') {
        sitename = sitename ? sitename : '云店'
        if (to.path == '/index' || to.path == '/') {
            document.title = title ? `${sitename} - ${title}` : `${sitename}`
        } else {
            document.title = to.meta.title ? `${sitename} - ${to.meta.title}` : `${sitename}`
        }
    }

    console.log('to', to);
    //整页路由处理
    if (to.meta.fullpage) {
        to.matched = [to.matched[to.matched.length - 1]]
    }
    // next()
    // NProgress.done()
    if (to.path.indexOf('/user') >= 0) {
        if (store.getters['token/isLogin']) {
            // console.log('1111', to.path);
            next()
            NProgress.done()
        } else {
            console.log('未登录', to.path, to.fullPath);
            console.log('login', to.fullPath.indexOf('/user/index') > -1);

            if (to.fullPath.indexOf('/user/login') > -1) {
                next()
            } else if (to.fullPath.indexOf('/user/register') > -1) {
                next()
            } else if (to.fullPath.indexOf('/user/order/index') > -1) {
                next()
            } else if (to.fullPath.indexOf('/user/order/desc') > -1) {
                next()
            } else if (to.fullPath.indexOf('/user/findpwd') > -1) {
                next()
            } else if (to.fullPath.indexOf('/user/kefu') > -1) {
                next()
            } else if (to.fullPath.indexOf('/user/index') > -1) {
                console.log('用户中心');
                next()
            } else {
                console.log('用户中心操作但未登录, 跳转登录');
                next({
                    path: '/user/login',
                    query: {
                        redirect: to.fullPath
                    }
                })
                // NProgress.done()
                // next(params)
            }
            NProgress.done()
            // console.log('2222', to.path);
        }
    } else {
        // console.log('3333', to.path);
        NProgress.done()
        next()
    }
});

//转换
function filterAsyncRouter(routerMap) {
    const accessedRouters = []
    routerMap.forEach(item => {
        item.meta = item.meta ? item.meta : {};
        //处理外部链接特殊路由
        //MAP转路由对象
        var route = {
            path: item.path,
            name: item.name ? item.name : parseRouteName(item.path),
            meta: item.meta,
            redirect: item.redirect,
            children: item.children ? filterAsyncRouter(item.children) : null,
            component: loadComponent(item),
            componentPath: parseComponent(item)
        }
        accessedRouters.push(route)
    })
    return accessedRouters
}

// 解析路由Name
function parseRouteName(path) {
    let arr = path.split('/')
    let name = '';
    arr.forEach(item => {
        if (name == '') {
            name = item
        } else {
            name += firstToUpper(item)
        }
    });
    return name
}

// 首字母转大写
function firstToUpper(str) {
    str = str.trim()
    return str.toLowerCase().replace(str[0], str[0].toUpperCase());
}

function loadComponent(item) {
    if (item && (item.component || item.path)) {
        if (item.component) {
            return () =>
                import(`@/views/${item.component}`)
        } else {
            return () =>
                import(`@/views/${item.path}`)
        }
    } else {
        return () =>
            import(`@/views/404`)
    }
}

function parseComponent(item) {
    if (item && (item.component || item.path)) {
        if (item.component) {
            return `@/views/${item.component}`
        } else {
            return `@/views/${item.path}`
        }
    } else {
        return `@/views/404`
    }
}

// function isHasChildren(item) {
// 	if (item.children && Array.isArray(item.children) && item.children.length > 0) {
// 		return 'undefined' != typeof item.children[0].path && item.children[0].path != ''
// 	}
// 	return false
// }

//路由扁平化
function flatAsyncRoutes(routes, breadcrumb = []) {
    let res = []
    routes.forEach(route => {
        const tmp = {...route}
        if (tmp.children) {
            let childrenBreadcrumb = [...breadcrumb]
            childrenBreadcrumb.push(route)
            let tmpRoute = {...route}
            tmpRoute.meta.breadcrumb = childrenBreadcrumb
            delete tmpRoute.children
            res.push(tmpRoute)
            let childrenRoutes = flatAsyncRoutes(tmp.children, childrenBreadcrumb)
            childrenRoutes.map(item => {
                res.push(item)
            })
        } else {
            let tmpBreadcrumb = [...breadcrumb]
            tmpBreadcrumb.push(tmp)
            tmp.meta.breadcrumb = tmpBreadcrumb
            res.push(tmp)
        }
    })
    return res
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js